module.exports = __webpack_public_path__ + "media/images/search-7b82c3e4c7df05d63019cbc1ca27f886.svg";